$('.variants-selector').on('click', function(event) {
    if ($(event.target).closest('.bundle-detail').length) {
        return;
    }

    $('.variants-selector').removeClass('selected')
    let id = $(this).data('id');

    $(this).addClass('selected');
    $('.variants-selector').attr('aria-pressed', 'false');
    $(this).attr('aria-pressed', 'true');

    $(`.variants-option #${id}`).trigger('click');
});

function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener('focus', () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');

    }, true);
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {
            bubbles: true
        })

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': `application/${type}`
        }
    };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                parentMenuElement && parentMenuElement.classList.add('submenu-open');
                !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;

        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
            details.removeAttribute('open');
            details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
            submenu.classList.remove('submenu-open');
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        removeTrapFocus(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
        this.header.classList.add('menu-open');

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove('menu-open');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener(
            'click',
            this.hide.bind(this, false)
        );
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
            });
        }
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        });
    }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) deferredElement.focus();
        }
    }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.slider || !this.nextButton) return;

        this.initPages();
        const resizeObserver = new ResizeObserver(entries => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    update() {
        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage != previousPage) {
            this.dispatchEvent(new CustomEvent('slideChanged', {
                detail: {
                    currentPage: this.currentPage,
                    currentElement: this.sliderItemsToShow[this.currentPage - 1]
                }
            }));
        }

        if (this.enableSliderLooping) return;

        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            this.prevButton.setAttribute('disabled', 'disabled');
        } else {
            this.prevButton.removeAttribute('disabled');
        }

        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
            this.nextButton.setAttribute('disabled', 'disabled');
        } else {
            this.nextButton.removeAttribute('disabled');
        }
    }

    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }

    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        this.enableSliderLooping = true;

        if (!this.sliderControlWrapper) return;

        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
        this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
        this.setSlideVisibility();

        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }

    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
        this.autoplaySpeed = this.slider.dataset.speed * 1000;

        this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
        this.addEventListener('mouseover', this.focusInHandling.bind(this));
        this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
        this.addEventListener('focusin', this.focusInHandling.bind(this));
        this.addEventListener('focusout', this.focusOutHandling.bind(this));

        this.play();
        this.autoplayButtonIsSetToPlay = true;
    }

    onButtonClick(event) {
        super.onButtonClick(event);
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

        if (!isFirstSlide && !isLastSlide) return;

        if (isFirstSlide && event.currentTarget.name === 'previous') {
            this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === 'next') {
            this.slideScrollPosition = 0;
        }
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
        this.prevButton.removeAttribute('disabled');

        if (!this.sliderControlButtons.length) return;

        this.sliderControlButtons.forEach(link => {
            link.classList.remove('slider-counter__link--active');
            link.removeAttribute('aria-current');
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
        this.play();
    }

    focusInHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
            this.play();
        } else if (this.autoplayButtonIsSetToPlay) {
            this.pause();
        }
    }

    play() {
        this.slider.setAttribute('aria-live', 'off');
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
        this.slider.setAttribute('aria-live', 'polite');
        clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
        } else {
            this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
        }
    }

    autoRotateSlides() {
        const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }

    setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, index) => {
            const button = item.querySelector('a');
            if (index === this.currentPage - 1) {
                if (button) button.removeAttribute('tabindex');
                item.setAttribute('aria-hidden', 'false');
                item.removeAttribute('tabindex');
            } else {
                if (button) button.setAttribute('tabindex', '-1');
                item.setAttribute('aria-hidden', 'true');
                item.setAttribute('tabindex', '-1');
            }
        });
    }

    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }
}

customElements.define('slideshow-component', SlideshowComponent);

function syncProductNotifySubscriptionState(button) {
    const subscribed = button.classList.contains('btn-product-notify') && button.notifySubscriptions?.has(button.dataset.variantId);
    if (!subscribed) return;

    const buttonText = button.querySelector('span');
    if (buttonText) buttonText.textContent = button.dataset.labelSubscribed;
    button.setAttribute('disabled', 'disabled');
    button.setAttribute('aria-disabled', 'true');
    delete button.dataset.notifyTarget;
    button.removeAttribute('aria-controls');
    button.removeAttribute('aria-haspopup');
}

function getVariantOptionState(variants, selectedOptions, optionIndex, optionValue) {
    const matchingVariants = variants.filter((variant) => {
        if (variant.options[optionIndex] !== optionValue) return false;

        return selectedOptions.slice(0, optionIndex).every((selectedOption, index) => {
            return variant.options[index] === selectedOption;
        });
    });

    return {
        exists: matchingVariants.length > 0,
        available: matchingVariants.some((variant) => variant.available)
    };
}

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updatePickupAvailability();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true, 'Unavailable');
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.syncBuyNowState();
            this.renderProductInfo();
            this.updateShareUrl();
        }

        $('[name=quantity]').val(1);
        this.closest('.product')?.querySelector('product-free-gifts')?.syncQuantity?.();

        this.updateData();
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateData() {

        $.ajax({
            type: 'GET',
            url: window.location.href,
            dataType: 'html',
            success: function(dataHtml) {

                let model = $(dataHtml).find('.variant--model').html();
                let color = $(dataHtml).find('.variant--color').html();

                $('.variant--model').html(model);
                $('.variant--color').html(color);

            },
            error: function(xhr, status, error) {
                console.error('Error fetching data data:', error);
            }
        });
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;

        if (!this.currentVariant.featured_media) return;

        /* $('.thumbnail-slider').find('.swiper-slide[data-media-id="'+this.currentVariant.featured_media.id+'"]').trigger('click'); */
        const targetIndex = $('[data-media-id="'+this.currentVariant.featured_media.id+'"]').index();
        sliderThumbs.slideTo(targetIndex);
        sliderImages.slideTo(targetIndex, 0);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('#main-id');

            $('.btn-bn').attr('data-variant-id', this.currentVariant.id);
          
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        });
    }

    updateVariantStatuses() {
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        const selectedOptions = inputWrappers.map((option) => option.querySelector(':checked')?.value);

        inputWrappers.forEach((option, index) => {
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            this.setInputAvailability(optionInputs, selectedOptions, index);
        });
    }
    
      setInputAvailability(listOfOptions, selectedOptions, optionIndex) {
        listOfOptions.forEach((input) => {
            const state = getVariantOptionState(
                this.variantData,
                selectedOptions,
                optionIndex,
                input.getAttribute('value')
            );

            if (state.exists) {
                input.innerText = input.getAttribute('value');
            } else {
                input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
            }
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    syncBuyNowState() {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        const productFormWrapper = productForm?.closest('.product-form');
        const buyNowButton = productFormWrapper?.querySelector('.btn-product-buy-now');
        if (!buyNowButton) return;

        if (!this.preOrderVariants) {
            const source = productFormWrapper.querySelector('[data-product-preorder-variants]');
            try {
                this.preOrderVariants = source ? JSON.parse(source.textContent) : {};
            } catch (error) {
                console.error('Unable to read pre-order variants:', error);
                this.preOrderVariants = {};
            }
        }

        const available = !!this.currentVariant.available;
        const preOrder = available && this.preOrderVariants[this.currentVariant.id] === true;
        const label = !available
            ? buyNowButton.dataset.labelNotifyMe
            : preOrder
                ? buyNowButton.dataset.labelPreOrder
                : buyNowButton.dataset.labelBuyNow;
        const notifyTarget = available ? '' : buyNowButton.dataset.notifyDialogId;

        this.toggleAddButton(!available, 'Out Of Stock', true, label, notifyTarget);
    }

    renderProductInfo() {
        const variantId = this.currentVariant.id;
        const requestId = (this.productInfoRequestId || 0) + 1;
        this.productInfoRequestId = requestId;

        fetch(`${this.dataset.url}?variant=${variantId}`)
            .then((response) => response.text())
            .then((responseText) => {
                if (this.productInfoRequestId !== requestId || this.currentVariant?.id !== variantId) return;
                const html = new DOMParser().parseFromString(responseText, 'text/html')

                const destination = document.getElementById(`price`);
                const source = html.getElementById(`price`);

                if (source && destination) destination.innerHTML = source.innerHTML;

                // Updating Main Price
                const priceDestination = document.querySelector('.price-item--regular');
                const priceSource = html.querySelector('.price-item--regular');

                if (priceDestination && priceSource) priceDestination.innerHTML = priceSource.innerHTML

                //Updating Compare Price
                const comparePriceDestination = document.querySelector('.price-item--sale');
                const comparePriceSource = html.querySelector('.price-item--sale');
              
                // Discount tag
                const discountTagDestination = document.querySelector('.discount-tag');
                const discountTagSource = html.querySelector('.discount-tag');
    
                if (discountTagDestination && discountTagSource) {
                    discountTagDestination.innerHTML = discountTagSource.innerHTML;
                    discountTagDestination.classList.remove('hidden'); // Assuming it may be hidden by default
                } else if (discountTagDestination && !discountTagSource) {
                    discountTagDestination.remove(); // Remove if not applicable to current variant
                }

                // NAV HEADER PRICE
                const navHeaderOriginalPrices = document.querySelectorAll('.main-nav-header-section .price-regular');
                const navHeaderComparePrices = document.querySelectorAll('.main-nav-header-section .product-compare-price');
                
                const navHeaderOriginalPriceSources = html.querySelectorAll('.main-nav-header-section .price-regular');
                const navHeaderComparePriceSources = html.querySelectorAll('.main-nav-header-section .product-compare-price');
                
                // Update all price-regular elements
                navHeaderOriginalPrices.forEach((el, index) => {
                  if (navHeaderOriginalPriceSources[index]) {
                    el.innerHTML = navHeaderOriginalPriceSources[index].innerHTML;
                  }
                });
                
                // Update all product-compare-price elements
                navHeaderComparePrices.forEach((el, index) => {
                  if (navHeaderComparePriceSources[index]) {
                    el.innerHTML = navHeaderComparePriceSources[index].innerHTML;
                  }
                });
              
                // Save price (e.g. "Save $5.00")
                const savePriceDestination = document.querySelector('[data-save-price]');
                const savePriceSource = html.querySelector('[data-save-price]');
                if (savePriceDestination && savePriceSource) {
                    savePriceDestination.innerHTML = savePriceSource.innerHTML;
                    savePriceDestination.classList.remove('hidden');
                } else if (savePriceDestination && !savePriceSource) {
                    savePriceDestination.remove();
                }
              
                if (comparePriceDestination && comparePriceSource) comparePriceDestination.innerHTML = comparePriceSource.innerHTML

                const price = document.getElementById(`price`);

                if (price) price.classList.remove('visibility-hidden');
            })
            .catch((error) => console.error('Unable to update product information:', error));
    }

    toggleAddButton(disable = true, text, modifyClass = true, buyNowLabel = 'Buy Now', notifyTarget = '') {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        const buyNowWrappers = productForm.closest('.product-form')?.querySelectorAll('.btn-product-buy-now') || [];
        const dynamicBuyNowWrappers = productForm.closest('.product-form')?.querySelectorAll('.btn-product-buy-now-dynamic') || [];
        const dynamicBuyNowButtons = productForm.closest('.product-form')?.querySelectorAll('.btn-product-buy-now-dynamic .shopify-payment-button__button') || [];
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;

            $('.product-nav .btn-atc').attr('disabled', true);
            $('.product-nav .btn-atc').html('Sold Out');
            buyNowWrappers.forEach((button) => {
                const buttonText = button.querySelector('span');
                if (buttonText) buttonText.textContent = buyNowLabel;

                if (notifyTarget) {
                    button.classList.add('btn-product-notify');
                    button.dataset.notifyTarget = notifyTarget;
                    button.setAttribute('aria-controls', notifyTarget);
                    button.setAttribute('aria-haspopup', 'dialog');
                    button.removeAttribute('disabled');
                    button.removeAttribute('aria-disabled');
                } else {
                    button.classList.remove('btn-product-notify');
                    delete button.dataset.notifyTarget;
                    button.removeAttribute('aria-controls');
                    button.removeAttribute('aria-haspopup');
                    button.setAttribute('disabled', 'disabled');
                    button.setAttribute('aria-disabled', 'true');
                }
            });
            dynamicBuyNowWrappers.forEach((wrapper) => {
                wrapper.hidden = true;
            });
            dynamicBuyNowButtons.forEach((button) => {
                button.setAttribute('disabled', 'disabled');
                button.setAttribute('aria-disabled', 'true');
            });
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = 'Add To Cart';

            $('.product-nav .btn-atc').removeAttr('disabled');
            $('.product-nav .btn-atc').html('Buy Now');
                      
            buyNowWrappers.forEach((button) => {
                const buttonText = button.querySelector('span');
                if (buttonText) buttonText.textContent = buyNowLabel;
                button.classList.remove('btn-product-notify');
                delete button.dataset.notifyTarget;
                button.removeAttribute('aria-controls');
                button.removeAttribute('aria-haspopup');
                button.removeAttribute('disabled');
                button.removeAttribute('aria-disabled');
            });
            dynamicBuyNowWrappers.forEach((wrapper) => {
                wrapper.hidden = false;
            });
            dynamicBuyNowButtons.forEach((button) => {
                button.removeAttribute('disabled');
                button.removeAttribute('aria-disabled');
            });
        }

        buyNowWrappers.forEach(syncProductNotifySubscriptionState);

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = 'Unavailable';
        if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    setInputAvailability(listOfOptions, selectedOptions, optionIndex) {
        listOfOptions.forEach((input) => {
            const state = getVariantOptionState(
                this.variantData,
                selectedOptions,
                optionIndex,
                input.getAttribute('value')
            );

            input.classList.toggle('disabled', !state.exists);
            input.classList.toggle('sold-out', state.exists && !state.available);

            const inputId = input.getAttribute('id');
            const selector = this.querySelector(`.variants-selector[data-id="${inputId}"]`);
            if (!selector) return;

            selector.classList.toggle('disabled', !state.exists);
            selector.classList.toggle('sold-out', state.exists && !state.available);

            if (state.exists) {
                selector.setAttribute('tabindex', '0');
                selector.removeAttribute('aria-disabled');
            } else {
                selector.setAttribute('tabindex', '-1');
                selector.setAttribute('aria-disabled', 'true');
            }
        });
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);



// ADDED SCRIPT
// THIS CODE FOR triggers adding the product to the cart and proceeds to checkout with all items in the cart.
// const buyNowBtn = document.querySelector('.btn-product-buy-now');

// if (buyNowBtn) {
//     buyNowBtn.addEventListener('click', function () {
//           if (buyNowBtn.hasAttribute('disabled')) return;
      
//           const variantId = buyNowBtn.getAttribute('data-variant-id');
//           const quantity = $('quantity-input .quantity__input').val();
      
//           if (variantId) {
//             window.location.href = `/cart/${variantId}:${quantity}`;
//           }

      
//           let formData = $('product-form .atc-form').serialize();
      
//           $.ajax({
//               type: 'POST',
//               url: '/cart/add.js',
//               data: formData,
//               dataType: 'json',
//               success: function (response) {
//                   window.location.href = '/checkout';
//               },
//               error: function (xhr, status, error) {
//                   console.error('Error adding product to cart:', error);
//               }
//           });
//     });
// }

document.addEventListener('click', async function (event) {
    const buyNowBtn = event.target.closest('.btn-product-buy-now');
    if (!buyNowBtn || buyNowBtn.hasAttribute('disabled')) return;

    if (buyNowBtn.classList.contains('btn-product-notify')) {
        const dialog = document.getElementById(buyNowBtn.dataset.notifyTarget);
        const variantInput = dialog?.querySelector('[data-notify-variant-id]');

        if (variantInput) variantInput.value = buyNowBtn.dataset.variantId;
        if (dialog && !dialog.open) dialog.showModal();
        return;
    }

    const productFormContainer = buyNowBtn.closest('.product-form');
    const atcForm = productFormContainer?.querySelector('.atc-form');
    if (!atcForm) return;
    if (atcForm.dataset.submitting === 'true') return;
    const giftSelector = atcForm.closest('.product')?.querySelector('product-free-gifts');

    const mainProductInput = atcForm.querySelector('#main-id');
    if (!mainProductInput || !mainProductInput.value) return;

    const quantityInput = atcForm.elements.namedItem('quantity');
    const mainQuantity = Math.max(parseInt(quantityInput?.value || '1', 10) || 1, 1);
    const accessoryInputs = atcForm.querySelectorAll('input[type="hidden"][name="id[]"]:not(#main-id)');

    const itemsMap = new Map();
    const addItem = (id, quantity) => {
        const parsedId = parseInt(id, 10);
        const parsedQty = parseInt(quantity, 10);
        if (!parsedId || !parsedQty) return;
        itemsMap.set(parsedId, (itemsMap.get(parsedId) || 0) + parsedQty);
    };

    addItem(mainProductInput.value, mainQuantity);
    accessoryInputs.forEach((input) => addItem(input.value, 1));

    let items = Array.from(itemsMap.entries()).map(([id, quantity]) => ({ id, quantity }));
    if (giftSelector) {
        try {
            items = giftSelector.getCartItems();
        } catch (error) {
            giftSelector.showError?.(giftSelector.dataset.errorMessage);
            return;
        }
    }
    if (!items.length) return;

    atcForm.dataset.submitting = 'true';
    buyNowBtn.setAttribute('disabled', 'disabled');
    buyNowBtn.setAttribute('aria-disabled', 'true');

    try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ items })
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.description || giftSelector?.dataset.errorMessage || `Buy now failed with status ${response.status}`);
        }

        window.location.href = (window.Shopify?.routes?.root || '/') + 'checkout';
    } catch (error) {
        console.error('Error processing custom buy now:', error);
        giftSelector?.showError(error.message);
        buyNowBtn.removeAttribute('disabled');
        buyNowBtn.removeAttribute('aria-disabled');
    } finally {
        delete atcForm.dataset.submitting;
    }
});

function syncDynamicBuyNowVisibility() {
    document.querySelectorAll('.btn-product-buy-now-dynamic').forEach((wrapper) => {
        const brandedButton = wrapper.querySelector('.shopify-payment-button__button--branded');
        const unbrandedButton = wrapper.querySelector('.shopify-payment-button__button--unbranded');
        const fallbackButton = wrapper.querySelector('.shopify-payment-button__button');
        const fallbackLabel = fallbackButton?.textContent?.trim().toLowerCase();
        const shouldHide = !brandedButton && (!!unbrandedButton || fallbackLabel === 'buy it now');

        wrapper.classList.toggle('is-hidden', shouldHide);
    });
}

document.querySelectorAll('.btn-product-buy-now-dynamic').forEach((wrapper) => {
    const observer = new MutationObserver(() => syncDynamicBuyNowVisibility());
    observer.observe(wrapper, { childList: true, subtree: true, attributes: true });
});

syncDynamicBuyNowVisibility();

$(document).ready(function () {
  syncDynamicBuyNowVisibility();
  const params = new URLSearchParams(window.location.search);
  const variantId = params.get('variant');
  if (!variantId) return;

  const variantJSON = document.querySelector('variant-radios script[type="application/json"]');
  if (!variantJSON) return;

  let variants = [];
  try {
    variants = JSON.parse(variantJSON.textContent);
  } catch (err) {
    return;
  }

  const variant = variants.find(v => String(v.id) === String(variantId));
  if (!variant) return;

  const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
  if (!mediaId) return;

  const interval = setInterval(() => {
    if (window.sliderImages && window.sliderThumbs) {
      clearInterval(interval);
      const $targetSlide = $(`.main-slider .swiper-slide[data-media-id="${mediaId}"]`);
      if ($targetSlide.length) {
        const targetIndex = $targetSlide.index();
        window.sliderImages.slideTo(targetIndex, 0);
        window.sliderThumbs.slideTo(targetIndex);
      }
    }
  }, 200);
});
